import React from "react";
import { IoStorefrontOutline, IoNewspaperOutline } from 'react-icons/io5';
import '../styles/BusinessInfo.css';

const Switch = ({ handleSelection, info, menu }) => {
    const containerClass = `switch-container ${info ? 'is-info' : 'is-menu'}`;
    return (
        <div className={containerClass}>
            <button onClick={() => handleSelection('info')} className={info ? 'switch-active' : 'switch-inactive'}>
                <IoNewspaperOutline size={40} color={info ? '#fff' : '#36261f'}/>
            </button>
            <button onClick={() => handleSelection('menu')} className={menu ? 'switch-active' : 'switch-inactive'}>
                <IoStorefrontOutline size={40} color={menu ? '#fff' : '#36261f'}/>
            </button>
        </div>
    )
};

export default Switch;
